import React from "react";
import { TextField } from "@mui/material";

const CustomTextarea = ({
  label,
  value,
  onChange,
  rows = 4,
  placeholder,
  disabled = false,
  required = false,
  error = false,
  helperText = "",
  name,
}) => {
  return (
    <TextField
      name={name}
      label={label}
      multiline
      rows={rows}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      variant="outlined"
      fullWidth
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
    />
  );
};

export default CustomTextarea;
